import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

import IconArrowNarrowUp from "assets/icons/arrow-narrow-up.svg";
import IconRectangle from "assets/icons/rectangle.svg";
import IconHLine from "assets/icons/hLine.svg";
import IconVLine from "assets/icons/vLine.svg";
import IconAddText from "assets/icons/addText.svg";

import IconArrowForwardUp from "assets/icons/arrow-forward-up.svg";
import IconArrowBackUp from "assets/icons/arrow-back-up.svg";

import { BiPlus } from "react-icons/bi";
import { BiMinus } from "react-icons/bi";
import { BiDownload } from "react-icons/bi";
import { BiSave } from "react-icons/bi";
import { BiX } from "react-icons/bi";

import IconZoom from "assets/icons/resetzoom.svg";

import EmailPDFModal from "../EmailPDF/EmailPDF.jsx";
import ExportPDFModal from "../ExportPDF/ExportPDF.jsx";

import Alert from "components/Alert";

import CustomModal from "components/CustomModal";
import i18next from "i18next";

import { updateCanvasInfo } from "actions/canvasInfoActions.js";
import { getCanvasInfo } from "actions/canvasInfoActions.js";

import { Container, Button } from "reactstrap";
import "./TopToolbar.css";
import {
  undo,
  redo,
  addRect,
  addText,
  getCanvas,
  addVLine,
  addHLine,
  addLineArrow,
  getCustomProps,
  resetState,
  setActiveStyle,
  isValidDate,
  getCanvasStateIndex,
  fittocanvas,
  handleZoomCanvas,
  getFittoCanvas,
  resetCanvasZoom
} from "../Helpers";
import { Input } from "reactstrap";

function TopToolbar(props) {
  const { month } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [alertMsg, setAlertMsg] = useState('');
  const [showAlertBanner, setShowAlertBanner] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selShortMonth, setSelShortMonth] = useState(null);
  const [tempShortMonth, setTempShortMonth] = useState(null);
  const [modal, setModal] = useState(false);
  const [exportmodal, setExportModal] = useState(false);
  const [fontSize, setFontSize] = useState('');
  const buyplanId = props.buyplanId;
  const [zoomLevel, setZoomLevel] = useState(100);
  const MIN_ZOOM = 25;
  const MAX_ZOOM = 500;

  function saveCanvas() {

  const canvas = getCanvas();
  const patchData = canvas.toJSON(getCustomProps());
  dispatch(updateCanvasInfo(buyplanId, month, patchData));

  setAlertMsg('Saved Successfully');
  setShowAlertBanner(true);

  setTimeout(() => {
    setShowAlertBanner(false);
  }, 2000);
  }

  const toggleModal = () => setModal(!modal);
  const exportPDFModal = () => setExportModal(!exportmodal);

  const closePopup = () => {
  setModal(!modal);
  };
  
  const closePage = () => {
  let path = history.location.pathname;
  path = path.replace(`/whiteboard/${month}`, '');
  history.push(
    path + '#showSummary'
  );
  }

  const closeExportPopup = () => {
  setExportModal(!exportmodal);
  };

  function exportAsPNG() {
  const currentTime = new Date();
  const month = currentTime.getMonth() + 1;
  const day = currentTime.getDate();
  const year = currentTime.getFullYear();
  const hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const seconds = currentTime.getSeconds();
  let fileName = month + '' + day + '' + year + '' + hours + '' + minutes + '' + seconds;
  const canvas = getCanvas();
  canvas.backgroundColor = "white";
  const link = document.createElement('a');
  fileName = fileName + ".png";
  link.setAttribute('href', canvas.toDataURL({
    format: 'png',
    quality: 0.8,
    multiplier: 4
  }));
  link.setAttribute('crossOrigin', 'anonymous');
  link.setAttribute('target', '_blank');
  link.setAttribute('download', fileName);
  if (document.createEvent) {
    const evtObj = document.createEvent('MouseEvents');
    evtObj.initEvent('click', true, true);
    link.dispatchEvent(evtObj);
  } else if (link.click) {
    link.click();
  }
  }

  const openWhiteboard = (shortMonth) => {
  if (getCanvasStateIndex() > 1) {
    setShowConfirmDialog(true);
    setTempShortMonth(shortMonth);
  } else {
    setSelShortMonth(shortMonth);
  }
  };

  useEffect(() => {
  if (selShortMonth)
    switchMonthCallbackFn();
  }, [selShortMonth])

  const onRejectCallback = () => {
  setShowConfirmDialog(false);
  setSelShortMonth(tempShortMonth);
  };

  const onSuccessCallback = () => {
  if (getCanvasStateIndex() > 1) {
    saveCanvas();
  }
  setShowConfirmDialog(false);
  setSelShortMonth(tempShortMonth);
  };

  const onCloseCallback = () => {
  setShowConfirmDialog(false);
  };

  const setToCanvas = () => {
  fittocanvas('FitToCanvas');
  setZoomLevel(parseInt(getFittoCanvas()));
  };

  const setCanvasZoom = (newZoom) => {
  if (newZoom < MIN_ZOOM) {
      newZoom = MIN_ZOOM;
    } else if (newZoom > MAX_ZOOM) {
      newZoom = MAX_ZOOM;
    }
    setZoomLevel(newZoom);
    handleZoomCanvas(newZoom);
  };

  // Zoom in function (increase zoom level)
  const zoomIn = () => {
  setCanvasZoom(zoomLevel + 25); // Increase by 25
  };

  // Zoom out function (decrease zoom level)
  const zoomOut = () => {
  setCanvasZoom(zoomLevel - 25); // Decrease by 25
  };

  // Reset Zoom function
  const resetZoom = () => {
  const canvas = getCanvas();
  if (canvas) {
    setZoomLevel(100); 
    resetCanvasZoom(100)
    canvas.renderAll();
  }
  };

  const switchMonthCallbackFn = () => {

  resetZoom();

  dispatch(getCanvasInfo(buyplanId, selShortMonth));

  setShowConfirmDialog(false);
  const canvas = getCanvas();
  canvas.clear();
  resetState();

  // $('.product').show();

  let path = history.location.pathname;
  path = path.replace(`/whiteboard/${month}`, '');

  path += `/whiteboard/${selShortMonth}`;

  history.push(
    path
  );
  };

  const FontSizeChange = (event) => {
    checkFontSize(event.target.value);
  };

  function changeFontSize(increment) {
  const canvas = getCanvas();
  const activeObject = canvas.getActiveObject();
  if (activeObject.type == "textbox") {
    const newFontSize = parseInt(activeObject.fontSize, 10) + increment;
    checkFontSize(newFontSize);
  }
}

const checkFontSize = (size) => {
  // eslint-disable-next-line no-console
  console.log(size)
  if(size < 0) {
    setFontSize(0);
  } else {
    setFontSize(size);
    setActiveStyle("fontSize", size);
  }
};

  return (
  <Container fluid>
    {showAlertBanner &&
    <Alert variant="info"> {alertMsg} </Alert>
    }
    <section>
    <div key='dialog'>
      {showConfirmDialog &&
      <CustomModal
        dismissible={false}
        showCloseBtn={false}
        modalSize={"100px"}
        isOpen={showConfirmDialog}
        title={i18next.t("general.confirmation")}
        body={
        <div className="font-weight-normal">
          You have unsaved changes, do you want to save these changes and continue?
        </div>
        }
        footer={
        <div>
          <Button className="mr-2" onClick={onSuccessCallback}>
          {i18next.t("general.yes")}
          </Button>
          <Button onClick={onRejectCallback}>{i18next.t("general.no")}</Button>
        </div>
        }
        closeModalCallback={() => onCloseCallback()}
      />
      }
    </div>
    </section>
    <div className="d-flex justify-content-between align-items-center flex-wrap">
    <div className="py-2">
      <div id="buyplanmonthsdiv" className="justify-content-start d-flex gap-2">
      {props.sortedBuyplanItems.entrySeq().map(([formattedDate, buyplanItem]) => {
        const shortMonth = buyplanItem.get("short_month");

        const date = buyplanItem.get("date");

        //Do not show pdf content for previous months
        if (!date || isValidDate(date)) {

        let classname = 'btnTool';
        if (shortMonth === month) {
          classname = 'btnTool active';
        }
        return (
          <div
          key={buyplanItem.get("short_month")}
          className="buyplan-summary-card"
          data-month={formattedDate}
          >
          {
            <Button onClick={() => openWhiteboard(shortMonth)} className={classname}>{shortMonth}</Button>
          }
          </div>
        );
        }
      })}
      </div>
    </div>
    <div className="py-1">
      <div className="editTools justify-content-center d-flex gap-2">
      <Button
        className="editToolBtn"
        color="outline-secondary"
        onClick={addText}
        title="Text"
      >
        <img src={IconAddText} alt="" />
      </Button>
      <Button
        className="editToolBtn fontSizeBtn"
        title="Text Size"
      >
      <img className="incrementText" onClick={() => changeFontSize(2)} src="/static/media/plus.e216b2332f935242e3c059c37914f56d.svg" alt="" />
        <Input className="mb-0"
        type="input"
        id="textSize"
        value={fontSize}
        onChange={FontSizeChange}
        >
        </Input>
      <img className="decrementText" onClick={() => changeFontSize(-2)} src="/static/media/minus.e6d9c7390657c8fd18e40379e2a881d7.svg" alt="" />
      </Button>
      <Button
        className="editToolBtn"
        color="outline-secondary"
        onClick={addVLine}
        title="Vertical Line"
      >
        <img src={IconVLine} alt="" />
      </Button>
      <Button
        className="editToolBtn"
        color="outline-secondary"
        onClick={addHLine}
        title="Horizontal Line"
      >
        <img src={IconHLine} alt="" />
      </Button>
      <Button
        color="outline-secondary"
        className="editToolBtn buttonarrow"
        title="Arrow Line"
        onClick={addLineArrow}
      >
        <img src={IconArrowNarrowUp} alt="" />
      </Button>
      <Button
        className="editToolBtn"
        color="outline-secondary"
        onClick={addRect}
        title="Rect"
      >
        <img src={IconRectangle} alt="" />
      </Button>
      </div>
    </div>
    <div className="py-1">
      <div className="d-flex justify-content-end align-items-center gap-2">

      <div className="zoomDiv">
      <div className="minus" title="Zoom Out" onClick={zoomOut}>
        <BiMinus />
      </div>
      <div className="dropdown">
        <div className="zoomDropdownOption">
        {zoomLevel}
        </div>
        <div className="dropdown-content zoomDropdown">
        <a onClick={setToCanvas}>Fit to canvas</a>
        <a onClick={resetZoom}>Reset zoom <img src={IconZoom} alt="" /> 0</a>
        </div>
      </div>
      <div className="plus" title="Zoom In" onClick={zoomIn}>
      <BiPlus />
      </div>
    </div>
      <div className="btnUndoRedo">
        <Button className="btnUndo" onClick={undo}>
        <img src={IconArrowBackUp} alt="" />
        </Button>
        <Button className="btnRedo" onClick={redo}>
        <img src={IconArrowForwardUp} alt="" />
        </Button>
      </div>
      <div className="dropdown">
        <Button className="btnTool btnExport">EXPORT <BiDownload size={26}/></Button>
        <div className="dropdown-content">
        <a onClick={toggleModal}>Email PDF</a>
        <a onClick={exportPDFModal}>Export PDF</a>
        <a onClick={exportAsPNG}>Export PNG</a>
        </div>
      </div>
      <Button className="btnTool btnSave" onClick={saveCanvas}>
        SAVE <BiSave size={26}/>
      </Button>
      <Button className="btnTool btnClose" onClick={closePage}>
        CLOSE
        <BiX size={26}/>
        {/* <img src={IconClose} alt="" /> */}
      </Button>
      </div>
    </div>
    <EmailPDFModal modal={modal} sortedBuyplanItems={props.sortedBuyplanItems} toggleModal={toggleModal} closePopup={closePopup} currMonth={month} buyplanId={buyplanId} currentUser={props.currentUser} />
    <ExportPDFModal modal={exportmodal} sortedBuyplanItems={props.sortedBuyplanItems} toggleModal={exportPDFModal} closePopup={closeExportPopup} currMonth={month} buyplanId={buyplanId} />
    </div>
  </Container>
  );
}

export default TopToolbar;
